export const COMMENTS = 
[
    {
        id: 0,
        campsiteId: 0,
        rating: 5, 
        text: "What a magnificent view!",
        author: "Tinus Lorvaldes",
        date: "2018-10-25T16:30Z"
    },
    {
        id: 1,
        campsiteId: 0,
        rating: 4, 
        text: "The campground was beautiful, but the bugs could bite sometimes.",
        author: "Brennen Ech",
        date: "2017-06-17T03:33Z"
    },
    {
        id: 2,
        campsiteId: 0,
        rating: 5, 
        text: "I caught a world-record-breaking trout here on my last visit.",
        author: "McKenzie Sebastian",
        date: "2019-02-18T18:12Z"
    },
    {
        id: 3,
        campsiteId: 0,
        rating: 5, 
        text: "A wonderful place to reconnect with nature.",
        author: "Jordan Runn",
        date: "2019-08-04T20:11Z"
    },
    {
        id: 4,
        campsiteId: 0,
        rating: 4, 
        text: "The stars at night were a revelation!",
        author: "Ann Dabramov",
        date: "2018-07-23T19:44Z"
    },
    {
        id: 5,
        campsiteId: 1,
        rating: 4, 
        text: "The campground was beautiful, but the bugs could bite sometimes.",
        author: "Brennen Ech",
        date: "2017-06-17T03:33Z"
    },
    {
        id: 6,
        campsiteId: 1,
        rating: 5, 
        text: "I caught a world-record-breaking trout here on my last visit.",
        author: "McKenzie Sebastian",
        date: "2019-02-18T18:12Z"
    },
    {
        id: 7,
        campsiteId: 1,
        rating: 5, 
        text: "A wonderful place to reconnect with nature.",
        author: "Jordan Runn",
        date: "2019-08-04T20:11Z"
    },
    {
        id: 8,
        campsiteId: 1,
        rating: 4, 
        text: "The stars at night were a revelation!",
        author: "Ann Dabramov",
        date: "2018-07-23T19:44Z"
    },
    {
        id: 9,
        campsiteId: 1,
        rating: 5, 
        text: "What a magnificent view!",
        author: "Tinus Lorvaldes",
        date: "2018-10-25T16:30Z"
    },
    {
        id: 10,
        campsiteId: 2,
        rating: 5, 
        text: "I caught a world-record-breaking trout here on my last visit.",
        author: "McKenzie Sebastian",
        date: "2019-02-18T18:12Z"
    },
    {
        id: 11,
        campsiteId: 2,
        rating: 5, 
        text: "A wonderful place to reconnect with nature.",
        author: "Jordan Runn",
        date: "2019-08-04T20:11Z"
    },
    {
        id: 12,
        campsiteId: 2,
        rating: 4, 
        text: "The stars at night were a revelation!",
        author: "Ann Dabramov",
        date: "2018-07-23T19:44Z"
    },
    {
        id: 13,
        campsiteId: 2,
        rating: 5, 
        text: "What a magnificent view!",
        author: "Tinus Lorvaldes",
        date: "2018-10-25T16:30Z"
    },
    {
        id: 14,
        campsiteId: 2,
        rating: 4, 
        text: "The campground was beautiful, but the bugs could bite sometimes.",
        author: "Brennen Ech",
        date: "2017-06-17T03:33Z"
    },
    {
        id: 15,
        campsiteId: 3,
        rating: 5, 
        text: "A wonderful place to reconnect with nature.",
        author: "Jordan Runn",
        date: "2019-08-04T20:11Z"
    },
    {
        id: 16,
        campsiteId: 3,
        rating: 4, 
        text: "The stars at night were a revelation!",
        author: "Ann Dabramov",
        date: "2018-07-23T19:44Z"
    },
    {
        id: 17,
        campsiteId: 3,
        rating: 5, 
        text: "What a magnificent view!",
        author: "Tinus Lorvaldes",
        date: "2018-10-25T16:30Z"
    },
    {
        id: 18,
        campsiteId: 3,
        rating: 4, 
        text: "The campground was beautiful, but the bugs could bite sometimes.",
        author: "Brennen Ech",
        date: "2017-06-17T03:33Z"
    },
    {
        id: 19,
        campsiteId: 3,
        rating: 5, 
        text: "I caught a world-record-breaking trout here on my last visit.",
        author: "McKenzie Sebastian",
        date: "2019-02-18T18:12Z"
    }
]